import { getLocation } from 'connected-react-router';
import type { Location } from 'history';
import { useSelector } from 'react-redux';
import type { RouterRootState } from 'connected-react-router';

type AppLocationState = {
  prevRoute?: string;
};

export const usePreviousRoute = (): string => {
  const routerLocation = useSelector(
    (state: RouterRootState<AppLocationState>) => getLocation(state) as Location<AppLocationState>
  );
  const prevRoute = routerLocation?.state?.prevRoute;
  return prevRoute || '/';
};
